var _path;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDataflow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: "new 0 0 20 20"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.2,11.4h-1.6V9.9c0-0.1-0.1-0.3-0.3-0.3h-3.9l-3.1-3.1V4h1.6c0.4,0,0.8-0.4,0.8-0.8V0.8c0-0.4-0.4-0.8-0.8-0.8H8.1 C7.7,0,7.3,0.4,7.3,0.8v2.4C7.3,3.6,7.7,4,8.1,4h1.6v2.6L6.6,9.7H2.6c-0.1,0-0.3,0.1-0.3,0.3v1.5H0.8c-0.4,0-0.8,0.4-0.8,0.8v2.4 c0,0.4,0.4,0.8,0.8,0.8h3.8c0.4,0,0.8-0.4,0.8-0.8v-2.4c0-0.4-0.4-0.8-0.8-0.8H2.8v-1.2h3.6l3.3,3.3V16H8.1c-0.4,0-0.8,0.4-0.8,0.8 v2.4c0,0.4,0.4,0.8,0.8,0.8h3.8c0.4,0,0.8-0.4,0.8-0.8v-2.4c0-0.4-0.4-0.8-0.8-0.8h-1.6v-2.5l3.3-3.3h3.5v1.2h-1.6 c-0.4,0-0.8,0.4-0.8,0.8v2.4c0,0.4,0.4,0.8,0.8,0.8h3.8c0.4,0,0.8-0.4,0.8-0.8v-2.4C20,11.8,19.6,11.4,19.2,11.4z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDataflow);
export default __webpack_public_path__ + "static/media/dataflow.1f793c55.svg";
export { ForwardRef as ReactComponent };